<template >
    <!-- section 1 -->
    <section class="  mt-32 px-20 mx-auto">
        <section class=" flex-col flexmobile2 items-center  flex justify-center ">
    <div >
        <img loading="lazy" class="md:max-h-[600px] pt-10 md:max-w-[800px]" src="https://res.cloudinary.com/dkdzcp4au/image/upload/v1726672530/screenmob_3_cgvifm.png" alt="">
    </div>
    <div >
        <img loading="lazy" class="md:max-h-[600px] pt-10 md:max-w-[800px]" src="https://res.cloudinary.com/dkdzcp4au/image/upload/v1726672545/screenmob_2_dmrxw3.png" alt="">
    </div>
    <div >
        <img loading="lazy" class="md:max-h-[700px] ml-6 md:ml-44 pt-10 md:max-w-[900px]" src="https://res.cloudinary.com/dkdzcp4au/image/upload/v1726672602/Group_34330_3_gf40e9.png" alt="">
    </div>
    <div >
        <img loading="lazy" class="md:max-h-[600px] md:ml-20 pt-10 md:max-w-[700px]" src="https://res.cloudinary.com/dkdzcp4au/image/upload/v1726672563/screenmob_4_kayxur.png" alt="">
    </div>
</section>
    </section>
    <!-- section 2 -->
    <section class=" mt-32 px-20 mx-auto">
    <p class="text-sky-200 text-2xl md:text-3xl font-semibold pt-6">Desktop Screens</p>
    <section class=" flexmobile2 flex justify-around mt-12">
    <img loading="lazy" class="w-[575px] md:h-[375px]" src="https://res.cloudinary.com/dkdzcp4au/image/upload/v1726672814/Group_34331_j0h32x.png" alt="">
    <img loading="lazy" class="w-[575px] md:h-[375px]" src="https://res.cloudinary.com/dkdzcp4au/image/upload/v1726672829/Group_34332_futxca.png" alt="">
    </section>
    <section class=" pt-10 flexmobile2  flex justify-around ">
    <img loading="lazy" class="w-[575px] md:h-[375px]" src="https://res.cloudinary.com/dkdzcp4au/image/upload/v1726672853/Group_34333_ge7bme.png" alt="">
    <img loading="lazy" class="w-[575px] md:h-[375px]" src="https://res.cloudinary.com/dkdzcp4au/image/upload/v1726672841/Group_34334_ifobjp.png" alt="">
    </section>
    <section class=" pt-10 flexmobile2 flex justify-around ">
    <img loading="lazy" class="w-[575px] md:h-[375px]" src="https://res.cloudinary.com/dkdzcp4au/image/upload/v1726672902/Group_34335_iijios.png" alt="">
    <img loading="lazy" class="w-[575px] md:h-[375px]" src="https://res.cloudinary.com/dkdzcp4au/image/upload/v1726672868/Group_34336_toqlhy.png" alt="">
    </section>
    <section class=" pt-10 flexmobile2 flex justify-center ">
    <img loading="lazy" class="w-[575px] md:h-[375px]" src="https://res.cloudinary.com/dkdzcp4au/image/upload/v1726672881/Group_34337_gykdzh.png" alt="">
    </section>
    </section>
    <!-- section 3 -->
    <section class="container flexmobile2 mx-auto px-20 md:mt-20">
        <div class="flex flexmobile justify-center">
        <div class=" flexmobile2 w-6xl  md:mt-32 ">
        <a
            href="https://www.figma.com/proto/PHr9pzwNzbJC3uMmh1z9mu/redesigned-next-home?node-id=1610-180&node-type=frame&t=JduEedmfaaklGUcC-1&scaling=scale-down&content-scaling=fixed&page-id=0%3A1&starting-point-node-id=1610%3A180"
              class="flex   relative p-10  bgColorr  top-2 md:mt-24  md:w-46 h-12 text-center text-xl rounded-[80px] shadow-[0px_4px_24px_rgba(0,0,0,0.5)]"
            >
              <span class="grow text-white relative bottom-4 text-center ">Checkout Mobile Prototype</span>
            </a>
            <a
            href="https://www.figma.com/proto/PHr9pzwNzbJC3uMmh1z9mu/redesigned-next-home?node-id=1610-1175&node-type=canvas&t=yoKUyE3EzclPsUVp-1&scaling=scale-down&content-scaling=fixed&page-id=149%3A2&starting-point-node-id=1610%3A931"
              class="flex   relative p-10  bgColorr top-10  md:top-2 md:mt-24  md:w-46 h-12 text-center text-xl rounded-[80px] shadow-[0px_4px_24px_rgba(0,0,0,0.5)]"
            >
              <span class="grow text-white relative bottom-4 text-center ">Checkout Desktop Prototype</span>
            </a>
      </div>
       </div>
       <section class=" flex top-10 relative md:top-44 justify-center flex-col flex-wrap mt max-md:mt-10">
        <h2 class="text-4xl text-center md:mb-20 font-semibold text-white">View other Projects</h2>
        <div class="self-start mt-2 ml-4 max-md:max-w-full">
          <div class="flex justify-center mb-20 gap-5 max-md:flex-col">
            <article class="flex pb-20  w-full max-md:ml-0 max-md:w-full">
                <div class="flex justify-between items-start font-bold text-white rounded-[50px] max-md:px-5 max-md:mt-10 max-md:flex-col max-md:items-center max-md:space-y-5">
    <router-link to="BakeryProject">
        <div class="cursor-pointer relative z-10 w-full max-w-full">
            <img loading="lazy" class="w-full h-full object-cover" src="https://res.cloudinary.com/dkdzcp4au/image/upload/v1726673689/Group_34338_1_q88zly.png" alt="">
        </div>
    </router-link>
    <router-link to="FirstProjectwrok">
        <div class="cursor-pointer relative z-10 ">
            <img loading="lazy" class="w-full mt-4 h-full object-cover" src="https://res.cloudinary.com/dkdzcp4au/image/upload/v1726673702/Group_34339_1_mjjqri.png" alt="">
        </div>
    </router-link>
</div>

            </article>
          </div>
        </div>
      </section>
    </section>
    </template>

<script>
export default {
  name: 'NextProjectThree',
 
};
</script>

<style>
.background-next{
    background-image: url("https://res.cloudinary.com/dkdzcp4au/image/upload/v1726670500/nextback_pqpmgd.png");
    background-size: cover;
}
.background-next2{
    background-image: url("https://res.cloudinary.com/dkdzcp4au/image/upload/v1726670500/nextback_pqpmgd.png");
    background-size: contain;
}
.Bakery-Linear{
    background: linear-gradient(90deg, rgba(248,146,146,1) 0%, rgba(137,2,35,1) 35%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}

@media (max-width:640px){
    .flexmobile2{
        display: block;
        margin-left: 0;
        padding: 10px;
        gap: 0 !important;
        font-size: 20px;
    }
    
    .max-w-small-mobile{
        max-width: 100%;
        width: 100%;
    }
    .hiddenMobile{
        visibility: hidden;
    }
}

</style>
